import { useState } from "react";
import "./StatusTransitionReasonModal.css";

// Collects a mandatory reason before committing a status transition to
// "Rejected"/"Re-opened" (the two defect statuses POST /defects/{id}/
// transition requires a reason for). Modeled directly on
// DueDateChangeModal.jsx's shape (fromValue/toValue + reason textarea) —
// kept as its own component rather than generalizing that one, since this
// is "before" vs "after" a STATUS, not a date, and the two concepts aren't
// worth forcing into one shared component for this small amount of shared
// markup.
export default function StatusTransitionReasonModal({ fromStatus, toStatus, onConfirm, onCancel }) {
  const [reason, setReason] = useState("");
  const [err, setErr] = useState("");

  function handleConfirm() {
    const trimmed = reason.trim();
    if (!trimmed) {
      setErr("Please provide a reason for this change.");
      return;
    }
    onConfirm(trimmed);
  }

  return (
    <div className="strm-scrim" onClick={onCancel}>
      <div className="strm-box" onClick={(e) => e.stopPropagation()}>
        <div className="strm-header">
          <span className="strm-title">Status Changed</span>
        </div>
        <div className="strm-body">
          <div className="strm-statuses">
            <div className="strm-status-item">
              <span className="strm-status-label">From</span>
              <span className="strm-status-val strm-status-val--old">{fromStatus}</span>
            </div>
            <span className="strm-arrow">→</span>
            <div className="strm-status-item">
              <span className="strm-status-label">To</span>
              <span className="strm-status-val strm-status-val--new">{toStatus}</span>
            </div>
          </div>
          <label className="strm-label">Reason <span className="strm-required">*</span></label>
          <textarea
            className={`strm-textarea${err ? " strm-textarea--err" : ""}`}
            rows={3}
            placeholder={`Explain why this is being marked "${toStatus}"…`}
            value={reason}
            onChange={(e) => { setReason(e.target.value); setErr(""); }}
            autoFocus
          />
          {err && <span className="strm-err">{err}</span>}
        </div>
        <div className="strm-footer">
          <button className="strm-cancel" onClick={onCancel}>Cancel</button>
          <button className="strm-confirm" onClick={handleConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
}
